<template>
  <div>
    <vue-upload-multiple-image
            primary-text="Main Image"
            drag-text="Drag an image here!"
            browse-text="or browse!"
            mark-is-primary-text="set as main image"
            drop-text="Well done - just drop it!"
            @before-remove="confirmImageRemove"
            @upload-success="uploadImageSuccess"
            @edit-image="editImage"
            :popup-text="this.maxImage == 1 ? 'You can choose one image!' : 'You can choose multiple images, up to ' + this.maxImage"
            :idUpload="'id_' + this.code"
            :editUpload="'edit_id_' + this.code"
            :data-images="this.images"
            :maxImage="this.maxImage"
    ></vue-upload-multiple-image>

    <Dialog :visible.sync="deleteImageDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
        <span>Are you sure you want to remove this image?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteImageDialog = false"/>
        <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="removeImage"/>
      </template>
    </Dialog>

  </div>
</template>

<script>

  export default {
    name: "ImageUploader",
    props: {
      images: {
        default: []
      },
      code: {
        default: ""
      },
      maxImage: {
        default: 5
      }
    },
    data() {
      return {
        deleteImageDialog: false,
        image: {}
      }
    },
    methods: {
      confirmImageRemove(index, done, fileList) {
        this.image = {
          "index": index,
          "done": done,
          "fileList": fileList
        };
        this.deleteImageDialog = true;
      },
      removeImage() {
        this.image.done();
        this.deleteImageDialog = false;
        this.$emit('remove-image', this.code, this.image.index);
        this.image = {}
      },
      uploadImageSuccess(formData, index, fileList) {
        this.$emit('new-image', this.code, fileList[index]);
      },
      editImage(formData, index, fileList) {
        this.$emit('edit-image', this.code, index, fileList);
      }
    }
  }
</script>

<style scoped>

</style>